module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/pretty-check/color-checkbox-switch/color-checkbox-switch.component.scss
// module id = ./src/app/features/pretty-check/color-checkbox-switch/color-checkbox-switch.component.scss
// module chunks = main